// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hefTxsf3T3HxY6WGaj1R {\n  color: var(--travel-primary-color);\n}\n\n.mxjphDwdXetZWwweUD_S {\n  color: var(--travel-secondary-color);\n}\n\n.kG7FYu92XWrLpHP9FAAH,\n.Krym25UowRjMSKnfNZk3 {\n  color: inherit;\n}\n", "",{"version":3,"sources":["webpack://./libs/shared/ui/buttons/link/link.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":[".primary {\n  color: var(--travel-primary-color);\n}\n\n.secondary {\n  color: var(--travel-secondary-color);\n}\n\n.inherit,\n.text {\n  color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary": "hefTxsf3T3HxY6WGaj1R",
	"secondary": "mxjphDwdXetZWwweUD_S",
	"inherit": "kG7FYu92XWrLpHP9FAAH",
	"text": "Krym25UowRjMSKnfNZk3"
};
export default ___CSS_LOADER_EXPORT___;
